import { getRuntimeEnv } from 'common';
import { useMemo } from 'react';
const bucketUrlProd = 'https://prod-stablehouse-assets.s3.eu-west-1.amazonaws.com';
const bucketUrlDev = 'https://stablehouse-assets.s3.eu-west-1.amazonaws.com';
export const useBucketAssetUrl = (bucketInstance, path, buildEnv, fallbackPath) => {
    const { srcUrl, fallbackSrcUrl } = useMemo(() => {
        if (!bucketInstance) {
            const { isLowerRegionEnv } = getRuntimeEnv(buildEnv);
            return {
                srcUrl: `${isLowerRegionEnv ? bucketUrlDev : bucketUrlProd}/${path}`,
                fallbackSrcUrl: `${isLowerRegionEnv ? bucketUrlDev : bucketUrlProd}/${fallbackPath}`,
            };
        }
        if (bucketInstance === 'prod') {
            return {
                srcUrl: `${bucketUrlProd}/${path}`,
                fallbackSrcUrl: `${bucketUrlProd}/${fallbackPath}`,
            };
        }
        return {
            srcUrl: `${bucketUrlDev}/${path}`,
            fallbackSrcUrl: `${bucketUrlDev}/${fallbackPath}`,
        };
    }, [bucketInstance, path, fallbackPath, buildEnv]);
    return { srcUrl, fallbackSrcUrl };
};
